import React from "react";
import DataTable from "@/components/Datatable/Datatable";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import SearchInput from "@/components/SearchInput/SearchInput";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { AdminCatalogProduct } from "../../api/fetchCatalogProducts";
import { useCatalogProductList } from "../../hooks/useCatalogProductList";
import ConfirmDeleteDialog from "../ConfirmDeleteDialog/ConfirmDeleteDialog";

const CatalogProductList: React.FC = () => {
  const {
    products,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    filters,
    handlePaginationChange,
    handleSortingChange,
    handleFilterChange,
    columns,
    deleteDialogState,
    closeDeleteDialog,
    handleConfirmDelete,
    isDeleting,
    goToCreateProduct,
  } = useCatalogProductList();

  return (
    <MainPageWrapper
      actions={
        <Button
          className="flex items-center gap-1"
          onClick={goToCreateProduct}
          size="sm"
        >
          <Plus className="w-4 h-4" />
          New Entry
        </Button>
      }
      error={error}
      subtitle="Manage the member-facing Product Catalog"
      title="Catalog Products"
    >
      <div className="mb-4 max-w-md">
        <SearchInput
          onChange={(searchTerm: string) => handleFilterChange(searchTerm)}
          placeholder="Search by name or slug..."
          value={filters.searchTerm || ""}
        />
      </div>
      <div className="relative">
        <DataTable<AdminCatalogProduct>
          columns={columns}
          data={products}
          error={error}
          loading={loading}
          noDataMessage="No catalog products found. Create one to get started."
          onPageChange={(newPageIndex, newPageSize) =>
            handlePaginationChange({
              pageIndex: newPageIndex,
              pageSize: newPageSize,
            })
          }
          onSortingChange={handleSortingChange}
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          rowKeyExtractor={(item) => item.id}
          sorting={sorting}
          totalCount={totalCount}
        />
      </div>

      <ConfirmDeleteDialog
        description={`Are you sure you want to delete "${deleteDialogState.productName}"? Members will no longer see it in the catalog.`}
        isOpen={deleteDialogState.isOpen}
        isPending={isDeleting}
        onClose={closeDeleteDialog}
        onConfirm={handleConfirmDelete}
        title="Delete catalog product"
      />
    </MainPageWrapper>
  );
};

export default CatalogProductList;
